import { Ummeldung } from '../../../../generated/model/ummeldung.model';
import { Produktdaten } from '../../../../generated/model/produktdaten.model';

/**
 * Whether the Produkt step (1) has every required input: the Zählertyp, and for a konventioneller
 * Zähler either a Zählerstand or the "kein Zählerstand" tick. The Zählernummer stays optional.
 */
export function isProduktStepComplete(ummeldung: Ummeldung | null): boolean {
  const produktdaten = ummeldung?.produktdaten ?? [];
  return produktdaten.length > 0 && produktdaten.every(isProduktComplete);
}

function isProduktComplete(produkt: Produktdaten): boolean {
  if (produkt.isSmartMeter === null || produkt.isSmartMeter === undefined) {
    return false;
  }
  return produkt.isSmartMeter || !!produkt.hasNoZaehlerstand || produkt.zaehlerstand != null;
}

/**
 * Whether the Ummeldedatum step (2) has its required input. Only a Smart Meter needs a chosen date —
 * a konventioneller Zähler derives it from the Zählerstand capture, or has none yet without one.
 */
export function isDatumStepComplete(ummeldung: Ummeldung | null): boolean {
  return ummeldung?.produktdaten?.at(0)?.isSmartMeter !== true || !!ummeldung?.ummeldedatum;
}
